import {
  AfterContentInit,
  AfterViewInit, ContentChild,
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges, ViewChild
} from '@angular/core';
// import {
//   DataBindingDirective,
//   GridComponent,
//   PageChangeEvent
// } from '@progress/kendo-angular-grid';
import { QueryRef } from 'apollo-angular';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

interface GridData {
  data: any[];
  total: number;
}

@Directive({
  selector: '[appApolloBinding]'
})
export class ApolloBindingDirective
  implements OnDestroy, OnChanges, AfterContentInit {
  @Input('appApolloBinding') queryRef: QueryRef<any>;
  @Input('filters') filters: any;
  @Input('sortField') sortField: string;
  @Input('statusFilter') statusFilter: string;
  @Input('paginator') paginator: MatPaginator;
  @Input() useCursorBasedPagination = false;
  dataSource = new MatTableDataSource<any>();
  cursor = 0;
  destroy = new Subject<any>();
  @Input() poll;
  @Input() skip: number;
  @Input() search: string;
  timeoutRef;

  constructor(private table: MatTable<any>) {

    this.table.dataSource = this.dataSource;
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const refreshFor = ['search', 'skip', 'statusFilter', 'filters'];

    const shouldRefresh = refreshFor.some(_filter => Boolean(changes[_filter]));
    if (shouldRefresh) {
      this.rebind();
    }
  }

  ngAfterContentInit() {
    this.queryRef.setVariables(this.options()).then(() => {
      if (this.poll) {
        this.queryRef.startPolling(1000);
      }
    });
    this.queryRef.valueChanges
      .pipe(
        filter(res => {
          const loading = res.loading;
          if (loading) {
            clearTimeout(this.timeoutRef);
            this.timeoutRef = setTimeout(() => {
              // this.grid.loading = true;
            }, 1000);
          } else {
            clearTimeout(this.timeoutRef);
            // this.grid.loading = false;
          }
          return !loading;
        }),
        tap(res => {
          if (res.data) {
            // this.grid.loading = false;
            clearTimeout(this.timeoutRef);
            const data = res.data;
            const entity = data[Object.keys(data)[0]];

            this.paginator.length = entity.totalCount;
            this.dataSource.data = entity.edges
              .map(item => {
                return item.node;
              })
            // this.notifyDataChange();
          }
        }),
        takeUntil(this.destroy)
      )
      .subscribe();

    this.paginator.page.subscribe(page => {
      const data = this.dataSource.data;
      console.log(data);
      // const page =
      const lastItemIndex = Math.max((page.pageIndex * page.pageSize) - 1, -1);


      const item = data[lastItemIndex];
      console.log(item);
      if (item && this.useCursorBasedPagination) {
        const { shortId } = item;
        this.cursor = this.useCursorBasedPagination ? shortId : lastItemIndex + 1;
      } else {
        this.cursor = lastItemIndex + 1;
      }

      this.rebind();
    });
    this.rebind();
  }

  public rebind(): void {
    // this.grid.loading = true; // optionally show loading indicator
    const filters = this.options();
    // this.queryRef.setVariables(filters);
    this.queryRef.stopPolling();

    this.queryRef.setVariables(filters).then(() => {
      this.queryRef.startPolling(1000)
    })

    this.queryRef.refetch(filters).then();
  }

  public options() {
    const options = {
      filters: {
        ...this.filters,
        first: this.paginator?.pageSize || 5,
        after: this.cursor || 0
      }
    };
    if (this.search) {

      options.filters.search = this.search;
    }
    if (this.statusFilter) {
      options.filters.filter = this.statusFilter;
    }
    return options;
  }

  // pageChange($event: PageChangeEvent) {}
}
